module.exports = __webpack_public_path__ + "b45494d6f3f69ace8fd3be8f712d2ce2.svg";